import { REQUEST, RECEIVE } from '../../types/referenten'
import { REQUEST as THEMEN_REQUEST} from '../../types/themen'

const initialState = {
    list: {},
    isFetching: false,
}

export default function reducer(state = initialState, action) {
    let currentReferenten
    switch (action.type) {
        case RECEIVE:
            currentReferenten = state.list;
            let newReferenten = action.data;
            return Object.assign({}, state, {
                list: Object.assign({}, currentReferenten, newReferenten),
                isFetching: false
            })
        case REQUEST:
            currentReferenten = state.list;
            let newId = action.data
            let newElement = {}
            newElement[newId] = null
            return Object.assign({}, state, {
                isFetching: true,
                list: Object.assign({}, currentReferenten, newElement)
            })
        case THEMEN_REQUEST:
            return Object.assign({}, state, {
                isFetching: false,
                list: {}
            })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/referenten/referenten.js